import { render } from "./FoldseekSearchButton.vue?vue&type=template&id=4fbdb7c9&scoped=true"
import script from "./FoldseekSearchButton.vue?vue&type=script&lang=js"
export * from "./FoldseekSearchButton.vue?vue&type=script&lang=js"

import "./FoldseekSearchButton.vue?vue&type=style&index=0&id=4fbdb7c9&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbdb7c9"]])

export default __exports__